import { onBeforeUnmount, onMounted } from 'vue'

export default function useOneTrustLenisPrevent() {
  let cookieModalObserver = null

  const addLenisPrevent = (root = document) => {
    if (typeof document === 'undefined') return

    if (root instanceof Element && root.matches('.ot-pc-scrollbar')) {
      root.setAttribute('data-lenis-prevent', '')
    }

    if (!(root instanceof Element) && root !== document) return

    root.querySelectorAll('.ot-pc-scrollbar').forEach((element) => {
      element.setAttribute('data-lenis-prevent', '')
    })
  }

  onMounted(() => {
    if (typeof document === 'undefined') return

    addLenisPrevent()

    if (typeof MutationObserver === 'undefined') return

    cookieModalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          addLenisPrevent(mutation.target)
          return
        }

        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) addLenisPrevent(node)
        })
      })
    })

    cookieModalObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    })
  })

  onBeforeUnmount(() => {
    if (!cookieModalObserver) return

    cookieModalObserver.disconnect()
    cookieModalObserver = null
  })
}
